import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import FilterBar from '@/components/system/FilterBar';
import { Search, Download, FileSpreadsheet } from 'lucide-react';

interface ContractOption {
  id: string;
  nome: string;
  numero_contrato: string;
}

interface Props {
  searchText: string;
  onSearchTextChange: (v: string) => void;
  contratoId: string;
  onContratoChange: (v: string) => void;
  tipoEvento: string;
  onTipoEventoChange: (v: string) => void;
  tipoAcao: string;
  onTipoAcaoChange: (v: string) => void;
  dateFrom: string;
  onDateFromChange: (v: string) => void;
  dateTo: string;
  onDateToChange: (v: string) => void;
  contratos: ContractOption[];
  onExportCSV: () => void;
  onExportPDF: () => void;
  hasEvents: boolean;
}

export const TimelineFilters: React.FC<Props> = ({
  searchText, onSearchTextChange,
  contratoId, onContratoChange,
  tipoEvento, onTipoEventoChange,
  tipoAcao, onTipoAcaoChange,
  dateFrom, onDateFromChange,
  dateTo, onDateToChange,
  contratos,
  onExportCSV, onExportPDF,
  hasEvents,
}) => {
  return (
    <FilterBar>
      {/* Text search */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          placeholder="Buscar eventos, usuários, descrições..."
          value={searchText}
          onChange={e => onSearchTextChange(e.target.value)}
          className="pl-8 h-9"
        />
      </div>

      {/* Contract filter */}
      <Select value={contratoId} onValueChange={onContratoChange}>
        <SelectTrigger className="w-[200px] h-9">
          <SelectValue placeholder="Todos os contratos" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os contratos</SelectItem>
          {contratos.map(c => (
            <SelectItem key={c.id} value={c.id}>
              {c.numero_contrato} — {c.nome}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Event type */}
      <Select value={tipoEvento} onValueChange={onTipoEventoChange}>
        <SelectTrigger className="w-[150px] h-9">
          <SelectValue placeholder="Tipo de evento" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os tipos</SelectItem>
          <SelectItem value="transicao">Transições</SelectItem>
          <SelectItem value="aprovacao">Aprovações</SelectItem>
          <SelectItem value="auditoria">Auditoria</SelectItem>
        </SelectContent>
      </Select>

      {/* Action type */}
      <Select value={tipoAcao} onValueChange={onTipoAcaoChange}>
        <SelectTrigger className="w-[150px] h-9">
          <SelectValue placeholder="Ação" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas as ações</SelectItem>
          <SelectItem value="insert">Criado</SelectItem>
          <SelectItem value="update">Modificado</SelectItem>
          <SelectItem value="delete">Eliminado</SelectItem>
          <SelectItem value="aprovado">Aprovado</SelectItem>
          <SelectItem value="rejeitado">Rejeitado</SelectItem>
        </SelectContent>
      </Select>

      {/* Date range */}
      <Input type="date" value={dateFrom} onChange={e => onDateFromChange(e.target.value)} className="w-[140px] h-9" />
      <Input type="date" value={dateTo} onChange={e => onDateToChange(e.target.value)} className="w-[140px] h-9" />

      {/* Export buttons */}
      <Button variant="outline" size="sm" onClick={onExportCSV} disabled={!hasEvents}>
        <FileSpreadsheet className="w-4 h-4 mr-1.5" />
        Excel
      </Button>
      <Button variant="outline" size="sm" onClick={onExportPDF} disabled={!hasEvents}>
        <Download className="w-4 h-4 mr-1.5" />
        PDF
      </Button>
    </FilterBar>
  );
};
